import { SubscriptionTier } from '@wwe-portal/entities/subscription.type';

const tierRank = Object.values(SubscriptionTier);
export const isBetterTier = (
  planA: { tier: SubscriptionTier | undefined },
  planB: { tier: SubscriptionTier }
) => {
  const planAIndex = tierRank.findIndex((tier) => tier === planA.tier);
  const planBIndex = tierRank.findIndex((tier) => tier === planB.tier);
  return planAIndex > planBIndex;
};

export const isBetterOrEqualTier = (
  planA: { tier: SubscriptionTier },
  planB: { tier: SubscriptionTier }
) => {
  return planA.tier === planB.tier || isBetterTier(planA, planB);
};
